import { z } from 'zod'

const AREA_COLUMN_IDS = [
  'coordinates',
  'name',
  'status',
  'assignment',
  'totalAccounts',
  'totalAssignedAccounts',
  'totalUnassignedAccounts',
  'filters',
  'lastRunAt',
  'createdBy',
  'createdAt',
  'updatedAt',
  'areaId',
] as const

export const AreaColumnIdSchema = z.enum(AREA_COLUMN_IDS)
export type AreaColumnId = z.infer<typeof AreaColumnIdSchema>
